import { cleanUndefinedKeysRecurse } from '../../lib/util';
import FlatRev from './FlatRev';
import { deliverableTypes } from './deliverableTypes';

/**
 * @typedef {import('./FlatRev').FlatRevData & ChildClassData} RenderRevData
 * @combinedata
 */
/**
 * @typedef {Object} ChildClassData
 * @property {number} _renderRevDataVer
 * @ignore
 */

const latestDataVer = 1;

export default class RenderRev extends FlatRev {
    static _targetType = deliverableTypes.renderRev;

    /**
     * @param {RenderRevData} inputData 
     */
    constructor(inputData) {
        super(inputData);
    }

    /**
     * @param {RenderRevData} inputData 
     */
    _reInit(inputData) {
        super._reInit(inputData);
        this._renderRevDataVer = inputData._renderRevDataVer || latestDataVer;

        if (this._renderRevDataVer !== latestDataVer) { throw new Error(`Metadata version not latest: Got ${this._renderRevDataVer}, should be ${latestDataVer}`); }
    }

    serialize({ includeTourData = this.isViewerDataIncluded } = {}) {
        const ser = {
            ...super.serialize({ includeTourData }),
            _renderRevDataVer: this._renderRevDataVer,
        };

        return cleanUndefinedKeysRecurse(ser);
    }

    getUpdatableData({ includeTourData = this.isViewerDataIncluded } = {}) {
        // we can only request to directly update these
        const updates = {
            ...super.getUpdatableData({ includeTourData }),
            _renderRevDataVer: this._renderRevDataVer, // even though we can't technically update this, send it so the backend can throw if we are sending the wrong data ver
        };

        return cleanUndefinedKeysRecurse(updates);
    }
}